<div class="fw-Navigation">
  <ul class="fw-Navigation_List">
      <ng-container *ngFor="let menu of menuItems">
        <li *ngIf="menu.adaOnly !== true && !menu.hideFromNavigation" [class.active]="selectedPageId == menu.id && !menu.hideFromNavigation">
          <a  *ngIf="menu.id == 'overview'"  href="javascript:void(0);" attr.aria-label="{{menu.name | pershingTranslate}}" (click)="handleNavigation(menu)" [attr.aria-current]="selectedPageId == menu.id ? 'page' : null">
            <div class="nav-{{menu.id}}"></div>
          </a>
          <a class="nav-{{menu.id}}"
            *ngIf="menu.id != 'overview' && menu.id != 'settings' && menu.adaOnly !== true && !menu.hideFromNavigation && !menu.isLink"
            href="javascript:void(0);" attr.aria-label="{{menu.name | pershingTranslate}}" (click)="handleNavigation(menu)" [attr.aria-current]="selectedPageId == menu.id ? 'page' : null">
            <span> {{menu.name| pershingTranslate}} </span>
          </a>
          <a class="nav-{{menu.id}}"
            *ngIf="menu.id != 'overview' && menu.id != 'settings' && menu.adaOnly !== true && !menu.hideFromNavigation && menu.isLink"
            href="javascript:void(0);" attr.aria-label="{{menu.name | pershingTranslate}}" (click)="handleNavigationLink(menu)" [attr.aria-current]="selectedPageId == menu.id ? 'page' : null">
            <span> {{menu.name| pershingTranslate}} </span>
          </a>
        </li>
        <li class="fw-Navigation_Divider fw-Navigation-{{selectedPageId}}"
          *ngIf="menu.adaOnly !== true && !menu.hideFromNavigation && menu.id == 'overview'"></li>
      </ng-container>
  </ul>
  <ng-container *ngIf="showPostLogin">
    <nxi-icons class="fw-Navigation_IconsGroup"></nxi-icons>
  </ng-container>
</div>
